module.exports = {
  title: {
    tourTrash: 'Tour Trash',
  },
  dragMessage: 'Choose images or drag here',
  uploadImage: 'Upload image',
  maxVideo: 'Please upload a video under 60 MB!',
  colorOpacity: 'Background Opacity',
  textColor: 'Text Color',
  buttonAlign: 'Button Align',
  textAlign: 'Text Align',
};
